import { SerializedError } from "@reduxjs/toolkit";

export function isRequestAborted(error: SerializedError | undefined): boolean {
  if (!error) return false;

  return !!(error.name === "AbortError" || error.message?.includes("aborted"));
}
